
<template>
  <div>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="!isHovered">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.78033 10.5303C4.48744 10.8232 4.01256 10.8232 3.71967 10.5303C3.4534 10.2641 3.4292 9.8474 3.64705 9.55379L3.71967 9.46967L7.189 6L3.71967 2.53033C3.4534 2.26406 3.4292 1.8474 3.64705 1.55379L3.71967 1.46967C3.98594 1.2034 4.4026 1.1792 4.69621 1.39705L4.78033 1.46967L8.78033 5.46967C9.0466 5.73594 9.0708 6.1526 8.85295 6.44621L8.78033 6.53033L4.78033 10.5303Z" fill="black"/>
    </svg>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="isHovered">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.78033 10.5303C4.48744 10.8232 4.01256 10.8232 3.71967 10.5303C3.4534 10.2641 3.4292 9.8474 3.64705 9.55379L3.71967 9.46967L7.189 6L3.71967 2.53033C3.4534 2.26406 3.4292 1.8474 3.64705 1.55379L3.71967 1.46967C3.98594 1.2034 4.4026 1.1792 4.69621 1.39705L4.78033 1.46967L8.78033 5.46967C9.0466 5.73594 9.0708 6.1526 8.85295 6.44621L8.78033 6.53033L4.78033 10.5303Z" fill="#BB4ECE"/>
    </svg>
  </div>
</template>
    
<script>
export default {
  components: {
  },
  props: {
    isHovered: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
svg {
  height: 18px;
}  
</style>
  
    